import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { FarmController } from 'src/controllers/farm.controller'
import { CreateFarmDTO } from 'src/dto/farm.dto'
import { toastSyncSuccess } from 'src/utils/syncToast'

const farmController = new FarmController()

export function useCreateFarm() {
  const { refreshUserData, farmConfig } = useAuth()
  const queryClient = useQueryClient()
  const baseFarmId = farmConfig?.idFazenda!

  return useMutation({
    mutationKey: ['createFarm'],
    mutationFn: (payload: CreateFarmDTO) => farmController.createFarm(baseFarmId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['getFarmList'] })
      void refreshUserData()
      toastSyncSuccess('Propriedade criada com sucesso')
    },
    onError: () => {
      toast.error('Erro ao criar propriedade.')
    }
  })
}
